import { CrtIcon, TestIcon} from '../../common/Icons';
import EntityPanel from '../../common/EntityPanel';
import { useTranslation } from 'react-i18next';

export function CrtPanel(props) {
const {t}=useTranslation();
const pathItems=[];
const values=[
	{key:t('Id'),value:props.crt.id},
	{key:t('Name'),value:props.crt.name}
];
	
return(
	  <EntityPanel header={props.crt.name} values={values} icon={<CrtIcon large/>} pathItems={pathItems} history={props.history}/> 
	)
}
export default CrtPanel;
